import {ICodeEmail, IEmailPasswordRecovery, ILoginEmail, INewPassword, IRegData} from "@/types/auth";
import DataRequest from "@/models/data-request";
import * as yup from "yup";


export class LoginEmail extends DataRequest implements ILoginEmail {
    username: string;
    password: string;

    constructor(data?: { username: string; password: string }) {
        super();
        this.username = data?.username;
        this.password = data?.password;
    }

    validationSchema() {
        return yup.object({
            username: yup.string().email('Введите корректный e-mail').required('Введите e-mail'),
            password: yup.string().min(6, 'Пароль должен быть не менее 6 символов').required('Введите пароль')
        })
    }
}

export class CodeEmail extends DataRequest implements ICodeEmail {
    code: string;

    constructor(data?: {code: string}) {
        super();
        this.code = data?.code ;
    }

    validationSchema() {
        return yup.object({
            code: yup.string().min(5, 'Неверный код').required('Неверный код'),
        })
    }
}


export class EmailPasswordRecovery extends DataRequest implements IEmailPasswordRecovery {
    email: string;

    constructor(data?:{email: string}) {
        super();
        this.email = data?.email;
    }

    validationSchema() {
        return yup.object({
            email: yup.string().email('Введите корректный e-mail').required('Введите e-mail'),
        })
    }
}


export class NewPassword extends DataRequest implements INewPassword {
    password1: string;
    password2: string;

    constructor(data?:{password1: string, password2: string}) {
        super();
        this.password1 = data?.password1 ;
        this.password2 = data?.password2 ;
    }
    validationSchema() {
        return yup.object({
            password1: yup
                .string()
                .min(6, 'Пароль должен быть не менее 6 символов')
                // .matches(PASSWORD_REGEX, "Слишком простой пароль")
                .required("Пожалуйста, введите пароль"),
            password2: yup
                .string()
                .oneOf([yup.ref('password1'), null], 'Пароли не совпадают')
                .required('Пожалуйста, повторите пароль'),
        })
    }

}

export class RegData extends DataRequest implements IRegData{
    email: string;
    f_name: string;
    l_name: string;
    p_name?: string;

    constructor(data?: { email: string, f_name: string, l_name: string, p_name?: string, }) {
        super();
        this.f_name = data?.f_name ;
        this.l_name = data?.l_name ;
        this.p_name = data?.p_name ;
        this.email = data?.email ;
    }

    validationSchema() {
        return yup.object({
            email: yup.string().email('Введите корректный e-mail').required('Введите e-mail'),
            f_name: yup.string().min(2, 'Имя не может быть короче 2 символов').required('Введите имя'),
            l_name: yup.string().min(2, 'Фамилия не может быть короче 2 символов').required('Введите Фамилию'),
            p_name: yup.string().min(2, 'Отчество не может быть короче 2 символов'),
        })
    }

}